import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../component/layout";
import { getItem } from "../../../utils/localStorage";
import { makeRequest2 } from "../../../utils/makeRequest";
import { getCashPayments, getUnpaidInvoices } from "../../../utils/urls";
import { toastify } from "../../../utils/toast";
import FacilityPaymentsTab from "./components/facility_payments_tab";
import MpesaTransactionsTab from "./components/mpesa-transactions-tab";
import BankPayments from "./components/bank-payments";
import WalletTab from "./components/wallet/wallet_tab";
import LandlordApprovalsTab from "./components/landlord_wallet/withdrawal_approvals";

function FacilityPayments() {
  // Tab Management
  const [activeIndex, setActiveIndex] = useState(0);
  const [paymentsSubTab, setPaymentsSubTab] = useState("mpesa"); // Default to 'mpesa' or 'bank'
  const [loading, setLoading] = useState(false);

  // Cash Payment States
  const [cashPayments, setCashPayments] = useState([]);

  useEffect(() => {
    fetchCashPayments();
  }, []);

  const fetchCashPayments = async () => {
    try {
      setLoading(true);
      const facilityId = await getItem("selectedFacilityId");
      const response = await makeRequest2(
        `${getCashPayments}/${facilityId}`,
        "GET",
      );

      console.log("CASH RESPONSE", response)

      if (response.success) {
        // const payments = response.data?.data?.payments || [];
        const payments = response.data?.payments || [];
        setCashPayments(payments);

        if (payments.length === 0) {
          toastify("No cash payments found for this facility", "info");
        }
      } else {
        setCashPayments([]);
        toastify(response.message || "Unable to fetch cash payments", "error");
      }
    } catch (error) {
      console.error("Error fetching cash payments:", error);
      setCashPayments([]);
      toastify(error.message || "Error fetching cash payments", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchInvoiceDetails = async (invoiceId, accountNumber) => {
    try {
      setLoading(true);
      const facilityId = await getItem("selectedFacilityId");

      // First try to get using invoice ID
      if (invoiceId) {
        try {
          const byIdUrl = `/api/app/levy_management/get_invoice_by_id/${facilityId}/${invoiceId}`;
          const response = await makeRequest2(byIdUrl, "GET");

          if (response && response.success && response.data) {
            return response.data;
          }
        } catch (err) {
          console.error(`Error fetching by ID: ${err.message}`);
        }
      }

      // Fallback: try to get using account number if available
      if (accountNumber) {
        try {
          const byAccountUrl = `/api/app/levy_management/get_invoice_by_account/${facilityId}/${accountNumber}`;
          const response = await makeRequest2(byAccountUrl, "GET");

          if (response && response.success && response.data) {
            return response.data;
          }
        } catch (err) {
          console.error(`Error fetching by account number: ${err.message}`);
        }
      }

      return null;
    } catch (error) {
      console.error(`General error in fetchInvoiceDetails: ${error.message}`);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const fetchUnpaidInvoices = async (clientId) => {
    try {
      if (!clientId) {
        console.error("Error: Missing clientId parameter");
        return [];
      }

      const facilityId = await getItem("selectedFacilityId");
      if (!facilityId) {
        console.error("Error: Missing facilityId");
        return [];
      }

      const apiUrl = `${getUnpaidInvoices}/${facilityId}/${clientId}`;
      const response = await makeRequest2(apiUrl, "GET");

      // Ensure we're properly parsing the response structure
      let invoicesData = [];

      if (response && response.success) {
        // Check where the actual array data is in the response
        if (Array.isArray(response.data)) {
          invoicesData = response.data;
        } else if (response.data && Array.isArray(response.data.data)) {
          invoicesData = response.data.data;
        } else if (response.data && typeof response.data === "object") {
          // Look for any array property that might contain the invoices
          const arrayProps = Object.keys(response.data).filter((key) =>
            Array.isArray(response.data[key]),
          );

          if (arrayProps.length > 0) {
            invoicesData = response.data[arrayProps[0]];
          }
        }

        // Final safety check to guarantee we always have an array
        if (!Array.isArray(invoicesData)) {
          invoicesData = [];
        }

        return invoicesData;
      } else {
        return [];
      }
    } catch (error) {
      console.error(`Error fetching unpaid invoices: ${error.message}`);
      return [];
    }
  };

  // Function to render the appropriate content for the Payments tab
  const renderPaymentsContent = () => {
  if (paymentsSubTab === "mpesa") {
    return <MpesaTransactionsTab />;
  } else {
    return <BankPayments />;
  }
};

  return (
    <Layout>
      <div className="page-header">
        <div className="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/app/">Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="">Finance</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="">Facility Payments</Link>
            </li>
          </ol>
        </div>
      </div>

      <div className="card">
        <div className="card-body py-0">
          <ul className="nav nav-tabs profile-tabs" id="myTab" role="tablist">
            <li className="nav-item">
              <button
                className={`nav-link ${activeIndex === 0 ? "active" : ""}`}
                onClick={() => setActiveIndex(0)}
                role="tab"
              >
                <i className="fa fa-money-bill mx-2"></i>
                Cash Payments
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeIndex === 1 ? "active" : ""}`}
                onClick={() => setActiveIndex(1)}
                role="tab"
              >
                <i className="fa fa-credit-card mx-2"></i>
                Digital Payments
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeIndex === 2 ? "active" : ""}`}
                onClick={() => setActiveIndex(2)}
                role="tab"
              >
                <i className="fas fa-wallet  mx-2"></i>
                Wallet
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeIndex === 3 ? "active" : ""}`}
                onClick={() => setActiveIndex(3)}
                role="tab"
              >
                <i className="fas fa-wallet  mx-2"></i>
                Landlord Wallet Approvals
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="tab-content">
        {/* Cash Payments Tab */}
        <div
          className={`tab-pane fade ${activeIndex === 0 ? "show active" : ""}`}
        >
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0">Cash Payments</h5>
            </div>
            <div className="card-body">
              <FacilityPaymentsTab
                cashPayments={cashPayments}
                refreshPayments={fetchCashPayments}
                fetchUnpaidInvoices={fetchUnpaidInvoices}
                fetchInvoiceDetails={fetchInvoiceDetails}
              />
            </div>
          </div>
        </div>

        {/* Combined Payments Tab (M-Pesa and Bank) */}
        <div
          className={`tab-pane fade ${activeIndex === 1 ? "show active" : ""}`}
        >
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0"> Payments</h5>

              {/* Sub-tabs for M-Pesa and Bank */}
              <ul className="nav nav-pills mt-3">
                <li className="nav-item">
                  <button
                    className={`nav-link btn-sm ${paymentsSubTab === "mpesa" ? "active" : ""}`}
                    onClick={() => setPaymentsSubTab("mpesa")}
                  >
                    <i className="fa fa-money-bill mx-1"></i>
                    M-Pesa Payments
                  </button>
                </li>
                <li className="nav-item ml-2">
                  <button
                    className={`nav-link btn-sm ${paymentsSubTab === "bank" ? "active" : ""}`}
                    onClick={() => setPaymentsSubTab("bank")}
                  >
                    <i className="fa fa-university mx-1"></i>
                    Bank Payments
                  </button>
                </li>
              </ul>
            </div>
            <div className="card-body">{renderPaymentsContent()}</div>
          </div>
        </div>
        {/* Wallet Tab */}
        <div
          className={`tab-pane fade ${activeIndex === 2 ? "show active" : ""}`}
        >
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0"> Wallet</h5>
            </div>
            <div className="card-body">
              {/* Wallet component */}
              <WalletTab />
            </div>
          </div>
        </div>

        {/*Lanlord Wallet Tab */}
        <div
          className={`tab-pane fade ${activeIndex === 3 ? "show active" : ""}`}
        >
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Wallet Approvals</h5>
            </div>
            <div className="card-body">
              {/* Wallet component */}
              <LandlordApprovalsTab />
            </div>
          </div>
        </div>

      </div>
    </Layout>
  );
}

export default FacilityPayments;
